import classes from './Spinner.module.css';

const Spinner: React.FC = () => {
    return <div className={classes.spinner}></div>;
};

export default Spinner;
